import styled from 'styled-components';

import Button from 'components/Button';

export const Wrapper = styled.div`
  padding: 0 40px;
`;

export const ButtonStyled = styled(Button)`
  display: block;
  margin: ${props => `${props.theme.spacing.default} auto`};
`;
